module.exports = __webpack_public_path__ + "static/media/Fitness-Group-2.6b568ba1.png";